export const imgcdn = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const api_json = "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.6126255&lng=77.04108959999999&page_type=DESKTOP_WEB_LISTING";

export const swiggy_menu_url = "https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.83106070000001&&submitAction=ENTER&restaurantId=";


// Image CDN URL for Restaurant card
export const IMG_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

// Image CDN URL for Restaurant Menu
export const ITEM_IMG_CDN_URL =
  "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";

// Swiggy API to get Restaurant data with foodfire erver
export const swiggy_api_URL =
  "https://foodfire.onrender.com/api/restaurants?lat=21.1702401&lng=72.83106070000001&page_type=DESKTOP_WEB_LISTING";

// Swiggy API to get Restaurant Menu data with foodfire erver
export const swiggy_menu_api_URL =
  "https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=21.1702401&lng=72.83106070000001&&submitAction=ENTER&restaurantId=";

// shimmer card unit
export const shimmer_card_unit = 20;

// shimmer Menu card unit
export const shimmer_menu_card_unit = 4;

// menu items api card type key
export const MENU_ITEM_TYPE_KEY = "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
export const RESTAURANT_TYPE_KEY = "type.googleapis.com/swiggy.presentation.food.v2.Restaurant";

// export const

export const food_menu_api = [
  {
    "id": 1,
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/110906/bo-ssam-dinner-for-4.c4a32e8801e2f0283e0565bbe8493149.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Momofuku",
    "dsc": "Half Bo Ssäm Dinner for 4-6",
    "price": 169,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": 2,
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133100/legendary-seafood-gumbo.a4010efb8ba0569ff59d68c3723f0963.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Commander's Palace",
    "dsc": "Legendary Seafood Gumbo",
    "price": 89,
    "rate": 4,
    "country": "New Orleans, LA"
  },
  {
    "id": 3,
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/137148/Gramercy-Tavern-Burger-and-Kielbasa-Kit-6.4.21-72ppi-1x1-15.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Gramercy Tavern",
    "dsc": "The Gramercy Tavern Burger - 4 Pack",
    "price": 99,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "the-coop-complete-fried-chicken-dinner-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134235/complete-fried-chicken-dinner-for-4.aeabf841c124b9cc2fb0166f27790999.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Blue Ribbon",
    "dsc": "\"The Coop\" Complete Fried Chicken Dinner for 4",
    "price": 119,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "traditional-beef-empanadas-with-llajua-sauce-12-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132987/traditional-meat-empanadas-with-llajua-sauce-12-pack.f2adcfeb4ccf027675047f1367ce83ca.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Chef Francis Mallmann",
    "dsc": "Traditional Beef Empanadas with Llajua Sauce - 12 Pack",
    "price": 99,
    "rate": 4,
    "country": "Patagonia, Argentina"
  },
  {
    "id": "pork-buns-12-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/110984/pork-buns-12-pack.67a379b014b23c7fd944ab48b9e720f6.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Momofuku",
    "dsc": "Pork Buns - 12 Pack",
    "price": 119,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "hot-honey-chicken-and-cornbread-waffles-for-2",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131336/marcus-hot-honey-chicken-and-cornbread-waffles-kit-for-4.618df9b9613b506f65c8342ab2e28b32.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Marcus Samuelsson's Streetbird",
    "dsc": "Marcus’ Hot Honey Chicken & Cornbread Waffles Kit for 4",
    "price": 99,
    "rate": 5,
    "country": "Harlem, NY"
  },
  {
    "id": "zahav-hummus-and-salatim-spread",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/114579/zahav-hummus-and-salatim-spread-for-6-8.137df09ea04ec063480f58ead8fe4b83.png?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Zahav",
    "dsc": "Zahav Hummus & Salatim Spread",
    "price": 99,
    "rate": 4,
    "country": "Philadelphia, PA"
  },
  {
    "id": "wood-fired-pizzas-best-seller-4-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/106027/wood-fired-pizzas-best-seller-4-pack.1653bb05922ba153ac178f8365d27f6d.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Pizzeria Bianco",
    "dsc": "Wood Fired Pizzas Best Seller - 4 Pack",
    "price": 129,
    "rate": 5,
    "country": "Phoenix, AZ"
  },
  {
    "id": "gramercy-tavern-mushroom-lasagna-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134704/gramercy-tavern-mushroom-lasagna-4-pack.88c671dec184d8bee908d6f5d8d860f9.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Gramercy Tavern",
    "dsc": "Gramercy Tavern Mushroom Lasagna for 4",
    "price": 99,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "brown-butter-lobster-roll-kit-4-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133343/brown-butter-lobster-roll-kit-4-pack.f97b1254243c8628ad1a5cd41227f5d7.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Eventide Oyster Co.",
    "dsc": "Brown Butter Lobster Roll Kit - 4 Pack",
    "price": 99,
    "rate": 5,
    "country": "Portland, ME"
  },
  {
    "id": "commanders-palace-three-course-dinner-for-2-shrimp-and-grits",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104768/commanders-palace-three-course-shrimp-and-grits-dinner-for-2.984253533e589547e834420efccc174a.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Commander's Palace",
    "dsc": "Commander's Palace Three-Course Shrimp & Grits Dinner for 2",
    "price": 169,
    "rate": 4,
    "country": "New Orleans, LA"
  },
  {
    "id": "butchers-feast-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104628/butchers-feast-for-4.cf40ca583a3bc2de78ac6355ee4b2995.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Cote Korean Steakhouse",
    "dsc": "The Original Butcher's Feast® for 4",
    "price": 259,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "whole-peking-duck-kit-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132862/decoys-whole-peking-duck-for-4.36f80dd5235f5495f279ed8765c33167.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "RedFarm",
    "dsc": "Whole Peking Duck Kit for 4",
    "price": 139,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "unconventional-texas-bbq-sampler-for-4-6",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/126766/unconventional-texas-bbq-sampler-for-4-6.ee40a926a0863ceeb13b1eafb987c7d1.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Underbelly by Chris Shepherd",
    "dsc": "Unconventional Texas BBQ Sampler for 4-6",
    "price": 119,
    "rate": 5,
    "country": "Houston, TX"
  },
  {
    "id": "diy-kit-for-2",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/113695/traditional-negiri-sushi-and-cutroll-kit-for-2.381bee7a4e1be32ad5818d93524b0bef.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Blue Ribbon Sushi",
    "dsc": "Blue Ribbon Sushi - DIY Kit for 2",
    "price": 129,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "zahav-lamb-shoulder-meal-kit",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/114544/zahav-lamb-shoulder-meal-kit-for-4-6.58cfa4d3d5eca52ac45b2d37a9d0f2d4.png?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Zahav",
    "dsc": "Zahav Lamb Shoulder Meal Kit",
    "price": 249,
    "rate": 5,
    "country": "Philadelphia, PA"
  },
  {
    "id": "the-classic-plateau-dinner-for-2",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131364/the-classic-plateau-dinner-for-2.9906825037a76931415a8fb5e8a2dcbd.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Blue Ribbon",
    "dsc": "The Classic Plateau Seafood Dinner for 2",
    "price": 139,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "mac-and-cheese-chicken-pot-pie-combo-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/112776/mac-and-cheese-chicken-pot-pie-combo-for-4.c77be8dcb4fabfa1870a2ff4a6bd4c6a.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Wolfgang Puck Catering",
    "dsc": "Mac and Cheese + Chicken Pot Pie Combo for 4",
    "price": 129,
    "rate": 4,
    "country": "Los Angeles, CA"
  },
  {
    "id": "prime-galbi-steak-feast-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104674/prime-galbi-steak-feast-for-4.51c78b5ba768078b166fe91325e60edc.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Cote Korean Steakhouse",
    "dsc": "Prime Galbi Steak Feast for 4",
    "price": 249,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "dry-aged-boneless-ribeye-steak-dinner-kit-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/126887/dry-aged-boneless-ribeye-steak-dinner-for-4.81c3bdc05fe6bdb2c2214709863120e0.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Chef Francis Mallmann",
    "dsc": "Dry-Aged Boneless Ribeye Steak Dinner Kit for 4",
    "price": 225,
    "rate": 4,
    "country": "Patagonia, Argentina"
  },
  {
    "id": "wood-fired-pizza-choose-your-own-4-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/104006/wood-fired-pizza-choose-your-own-4-pack.e36692807e17618a646885a8087a4c97.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Pizzeria Bianco",
    "dsc": "Wood Fired Pizza - Choose Your Own 4 Pack",
    "price": 135,
    "rate": 4,
    "country": "Phoenix, AZ"
  },
  {
    "id": "pasta-dinner-gift-basket",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/111490/pasta-sauce-gift-basket.e7d2b1afaeef767b7327843716d15203.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Fox & the Knife",
    "dsc": "Pasta Dinner Gift Basket",
    "price": 129,
    "rate": 5,
    "country": "Boston, MA"
  },
  {
    "id": "chinese-tea-smoked-whole-duck",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/112821/chinese-tea-smoked-whole-duck.97b321323431f1453d204a3ba9a35293.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Shirley Chung's Ms. Chi",
    "dsc": "Chinese Tea Smoked Whole Duck",
    "price": 119,
    "rate": 4,
    "country": "Los Angeles, CA"
  },
  {
    "id": "traditional-beef-empanadas-with-llajua-sauce-24-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133293/traditional-meat-empanadas-with-llajua-sauce-24-pack.800489d1d8db1e649e129968ed91e449.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Chef Francis Mallmann",
    "dsc": "Traditional Beef Empanadas with Llajua Sauce - 24 Pack",
    "price": 149,
    "rate": 4,
    "country": "Patagonia, Argentina"
  },
  {
    "id": "choose-your-own-pasta-dinner-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/111241/choose-your-own-pasta-dinner-for-4.1195531d1b5fd7958e85d2640bd4d5bf.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Fox & the Knife",
    "dsc": "Pasta Dinner for 4 - Choose Your Own",
    "price": 99,
    "rate": 5,
    "country": "Boston, MA"
  },
  {
    "id": "marcus-hot-fried-chicken-wings-for-2",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/129322/marcus-fried-chicken-wings.95e4f4d5cb4d3e069f4addcb3e33b111.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Marcus Samuelsson's Streetbird",
    "dsc": "Marcus’ Fried Chicken Wings for 2",
    "price": 99,
    "rate": 5,
    "country": "Harlem, NY"
  },
  {
    "id": "taco-combo-kit-for-4-6-choose-your-own",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133992/taco-combo-kit-for-4-6-choose-your-own.62a9fa8e0b5912c035e2999508fe36e1.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Johnny Sanchez",
    "dsc": "Taco Combo Kit for 4-6 - Choose Your Own",
    "price": 119,
    "rate": 4,
    "country": "New Orleans, LA"
  },
  {
    "id": "shiitake-mushroom-buns-12-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/110987/shiitake-mushroom-buns-12-pack.449e51af13ae6204f3c2914355d427ac.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Momofuku",
    "dsc": "Shiitake Mushroom Buns - 12 Pack",
    "price": 109,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "turtle-soup",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/102811/legendary-turtle-soup.12d6f4c9806c3cf11cd2ff2a160657e7.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Commander's Palace",
    "dsc": "Legendary Turtle Soup",
    "price": 89,
    "rate": 4,
    "country": "New Orleans, LA"
  },
  {
    "id": "blue-ribbon-special-sushi-diy-kit-for-2-3",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/119272/blue-ribbon-special-sushi-diy-kit-for-2-3.08c8f6c674366187e651ccb03cd1747d.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Blue Ribbon Sushi",
    "dsc": "Blue Ribbon Special Sushi - DIY Kit for 2-3",
    "price": 169,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "burger-au-poivre-kit-4-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/103477/burger-au-poivre-kit-4-pack.3ca0e39b02db753304cd185638dad518.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Raoul's",
    "dsc": "Burger Au Poivre Kit - 4 Pack",
    "price": 99,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "pork-and-shrimp-wontons-20-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/98019/pork-and-shrimp-wontons-20-pack.1489740a2c5ab4c5585b49ebbde2f1c1.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Shirley Chung's Ms. Chi",
    "dsc": "Pork and Shrimp Wontons - 20 Pack",
    "price": 69,
    "rate": 4,
    "country": "Los Angeles, CA"
  },
  {
    "id": "pasta-dinner-for-2-choose-your-own",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/112230/pasta-dinner-for-2-choose-your-own.f5edf5a6c05115eec571d2c2f3805300.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Fox & the Knife",
    "dsc": "Pasta Dinner for 2 - Choose Your Own",
    "price": 69,
    "rate": 5,
    "country": "Boston, MA"
  },
  {
    "id": "traditional-argentinian-asado-dinner-kit-for-10-12",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/126975/traditional-argentinian-asado-dinner-kit-for-8.0143a30b0ccda3282a3f81a0c13a6f7b.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Chef Francis Mallmann",
    "dsc": "Traditional Argentinian Asado Feast for 10-12",
    "price": 469,
    "rate": 5,
    "country": "Patagonia, Argentina"
  },
  {
    "id": "neapolitan-pizza-choose-your-own-4-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131291/neapolitan-pizza-choose-your-own-4-pack.e9e370c647523cb3b6a8ee6f60c9a9c1.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Pizzeria Delfina",
    "dsc": "Neapolitan Pizza - Choose Your Own 4 Pack",
    "price": 119,
    "rate": 4,
    "country": "San Francisco, CA"
  },
  {
    "id": "double-stack-burger-kit-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/122768/handf-double-stack-burger-kit-for-4.4ee9f54b1d6087e9996335f07c13e5cd.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Holeman & Finch",
    "dsc": "Double Stack Burger Kit for 4",
    "price": 79,
    "rate": 5,
    "country": "Atlanta, GA"
  },
  {
    "id": "bo-ssam-dinner-for-8-10",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/111005/bo-ssam-dinner-for-4-6.20cb5b3dede7ecca90c888aadc93567f.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Momofuku",
    "dsc": "Whole Bo Ssäm Dinner for 8-10",
    "price": 269,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "chicken-jiaozi-dumplings-giant-cheese-burger-potstickers-combo-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134028/chicken-jiaozi-dumplings-giant-cheese-burger-potstickers-best-seller-pack.908a1c285e5356202e5163fc03ede65e.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Shirley Chung's Ms. Chi",
    "dsc": "Ms. Chi Potstickers and Dumplings - Combo Pack",
    "price": 99,
    "rate": 5,
    "country": "Los Angeles, CA"
  },
  {
    "id": "vietnamese-dinner-kit-for-4-choose-your-own",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133221/vietnamese-dinner-kit-for-4-choose-your-own.6adf8528fae31fa5260ee6c1bed222c4.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "The Slanted Door",
    "dsc": "Vietnamese Dinner Kit for 4 - Choose Your Own",
    "price": 149,
    "rate": 4,
    "country": "San Francisco, CA"
  },
  {
    "id": "chicken-jiaozi-dumplings-20-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/97105/chicken-jiaozi-dumplings-20-pack.15df330a0f96492d492d6f3ed6518aa8.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Shirley Chung's Ms. Chi",
    "dsc": "Chicken Jiaozi Dumplings - 20 Pack",
    "price": 69,
    "rate": 4,
    "country": "Los Angeles, CA"
  },
  {
    "id": "whole-plate-short-rib-dinner-for-3-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/117831/whole-plate-short-rib-dinner-for-3-4.3d4f7a1d5441c0a3a50263c89ef3fb47.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Momofuku",
    "dsc": "Whole Plate Short Rib Dinner for 3-4",
    "price": 249,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "pasta-dinner-bestsellers-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/111245/pasta-dinner-bestsellers-for-4.94ca16a49a00a4f50714e827ab686510.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Fox & the Knife",
    "dsc": "Best Sellers - Pasta Dinner for 4",
    "price": 89,
    "rate": 4,
    "country": "Boston, MA"
  },
  {
    "id": "best-seller-ramen-kits-4-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/119444/best-seller-ramen-kits-for-4.6946ea916af35904079d82208a0cb7e2.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Ivan Ramen",
    "dsc": "Best Seller Ramen Kits for 4",
    "price": 149,
    "rate": 5,
    "country": "New York, NY"
  },
  {
    "id": "carnitas-taco-kit-for-2-3",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/133954/carnitas-taco-kit-for-2.8e93e32c7ad6399ab54ffd4ccffc648a.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Frontera Grill",
    "dsc": "Carnitas Taco Kit for 2-3",
    "price": 89,
    "rate": 5,
    "country": "Chicago, IL"
  },
  {
    "id": "neapolitan-pizza-choose-your-own-3-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/114414/neapolitan-pizza-choose-your-own-3-pack.5b29cea22f1eeee4b8d95057b9bc7abd.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Pizzeria Delfina",
    "dsc": "Neapolitan Pizza - Choose Your Own 3 Pack",
    "price": 99,
    "rate": 4,
    "country": "San Francisco, CA"
  },
  {
    "id": "brown-butter-lobster-roll-kit-6-pack",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/93518/brown-butter-lobster-roll-kit-6-pack.b09e74d8a0f05fa77d00773d2daf12c6.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Eventide Oyster Co.",
    "dsc": "Brown Butter Lobster Roll Kit - 6 Pack",
    "price": 149,
    "rate": 5,
    "country": "Portland, ME"
  },
  {
    "id": "taco-fiesta-pack-queso-margarita-mix-for-4-6",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/119163/taco-party-pack-queso-margarita-mix-for-4-6.1468490bf51e9f474a2562f8d0f76be9.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Johnny Sanchez",
    "dsc": "Taco Fiesta Pack + Queso + Margarita Mix for 4-6",
    "price": 179,
    "rate": 5,
    "country": "New Orleans, LA"
  },
  {
    "id": "the-crustacean-plateau-dinner-for-4-6",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131730/the-crustacean-plateau-dinner-for-4-6.d0de88df7471976c81acdcfa94806bee.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Blue Ribbon",
    "dsc": "The Crustacean Plateau Seafood Dinner for 4-6",
    "price": 239,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "the-family-coop-complete-fried-chicken-dinner-for-8",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132341/complete-fried-chicken-dinner-for-8.512f5bff5f9f22995de1408764b7c0ff.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Blue Ribbon",
    "dsc": "\"The Family Coop\" Complete Fried Chicken Dinner for 8-10",
    "price": 189,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "gramercy-tavern-burger-kielbasa-combo",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/135126/Gramercy-Tavern-Burger-and-Kielbasa-Kit-6.4.21-72ppi-1x1-47.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Gramercy Tavern",
    "dsc": "Gramercy Tavern Burger + Kielbasa Combo",
    "price": 149,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "lobster-pot-pie-and-crab-cake-combo-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/117760/lobster-pot-pie-and-crab-cake-combo-for-4.a3f470732ece5228abe8cdb25af96043.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Summer Shack",
    "dsc": "Lobster Pot Pie and Crab Cake Combo for 4",
    "price": 139,
    "rate": 4,
    "country": "Boston, MA"
  },
  {
    "id": "truffle-chicken-pot-pie-kit-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132863/chicken-pot-pie-kit-for-4.7fb17eea18a6ef99129f189fcc130fca.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Wolfgang Puck Catering",
    "dsc": "Truffle Chicken Pot Pie Kit for 4",
    "price": 139,
    "rate": 4,
    "country": "Los Angeles, CA"
  },
  {
    "id": "carnitas-taco-kit-for-4-6",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/122300/carnitas-taco-kit-for-4.984935855d88edab90fe5859999221cb.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Frontera Grill",
    "dsc": "Carnitas Taco Kit for 4-6",
    "price": 129,
    "rate": 5,
    "country": "Chicago, IL"
  },
  {
    "id": "gluten-free-chinese-orange-chicken-kit-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132017/gluten-free-chinese-orange-chicken-kit-for-4.b5618b86376b9ca33a0180504df4ccd8.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Shirley Chung's Ms. Chi",
    "dsc": "Gluten-Free Chinese Orange Chicken Kit for 4",
    "price": 79,
    "rate": 4,
    "country": "Los Angeles, CA"
  },
  {
    "id": "taiwanese-style-pork-chop-dinner-kit-for-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/107818/taiwanese-style-pork-chop-dinner-kit-for-4.af151d422000d25f084e36e5f83cccba.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Shirley Chung's Ms. Chi",
    "dsc": "Taiwanese Style Pork Chop Dinner Kit for 4",
    "price": 119,
    "rate": 5,
    "country": "Los Angeles, CA"
  },
  {
    "id": "best-seller-falafel-kit-for-6-vegan",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/134459/best-seller-falafel-kit-for-6.5dc557098f859293bc45cefda7ecb3af.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Taïm",
    "dsc": "Best Seller Falafel Kit for 6 (Vegan)",
    "price": 89,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "signature-spicy-tuna-crispy-rice-diy-kit-for-2-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/113679/spicy-tuna-crispy-rice-kit-for-4.53612097e152d97482a074c3250c6e28.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "Blue Ribbon Sushi",
    "dsc": "Signature Spicy Tuna Crispy Rice DIY Kit for 2-4",
    "price": 149,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "redfarm-signature-sampler-for-3-4",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/131850/redfarm-sampler-for-3-4.b47a4dad3b06d719e9fc17380238afd2.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "RedFarm",
    "dsc": "RedFarm Signature Sampler for 3-4",
    "price": 129,
    "rate": 4,
    "country": "New York, NY"
  },
  {
    "id": "yuzu-shio-ramen-kit-for-3",
    "img": "https://goldbelly.imgix.net/uploads/showcase_media_asset/image/132439/yuzu-shio-ramen-kit-for-3.eff2c00445f04ccad761867bf8083ab6.jpg?ixlib=react-9.0.2&auto=format&ar=1%3A1",
    "name": "AFURI",
    "dsc": "Yuzu Shio Ramen Kit for 3",
    "price": 89,
    "rate": 5,
    "country": "Portland, OR"
  }
]

export const RestaurantList = [
  {
       "info": {
            "id": "63939",
            "name": "Mahalaxmi Sweets",
            "cloudinaryImageId": "p03z6md3rbbxtz17lvbu",
            "locality": "Aliganj",
            "areaName": "Aliganj",
            "costForTwo": "₹200 for two",
            "cuisines": [
                 "Sweets",
                 "North Indian",
                 "Chinese",
                 "South Indian",
                 "Snacks",
                 "Fast Food"
            ],
            "avgRating": 4.5,
            "veg": true,
            "parentId": "8187",
            "avgRatingString": "4.5",
            "totalRatingsString": "10K+",
            "promoted": true,
            "adTrackingId": "cid=11981616~p=1~adgrpid=11981616#ag1~mp=SWIGGY_IN~bl=FOOD~eid=ae40e713-c9b7-4ef8-ad16-f1eab55f8e6c~aet=RESTAURANT~aeid=63939~srvts=1710779552940",
            "sla": {
                 "deliveryTime": 30,
                 "lastMileTravel": 5.5,
                 "serviceability": "SERVICEABLE",
                 "slaString": "30-35 mins",
                 "lastMileTravelString": "5.5 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-18 22:15:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textExtendedBadges": {

                      },
                      "textBased": {

                      },
                      "imageBased": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "₹125 OFF",
                 "subHeader": "ABOVE ₹249",
                 "discountTag": "FLAT DEAL"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "4.1",
                      "ratingCount": "5K+"
                 },
                 "source": "GOOGLE",
                 "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=63939",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },


  {
       "info": {
            "id": "413990",
            "name": "Shaban Chicken Tikka Corner",
            "cloudinaryImageId": "ibxv22qqion9h3nvfkhi",
            "locality": "Akbari Gate",
            "areaName": "Chowk",
            "costForTwo": "₹200 for two",
            "cuisines": [
                 "Lucknowi",
                 "Mughlai",
                 "Biryani"
            ],
            "avgRating": 4.5,
            "parentId": "254757",
            "avgRatingString": "4.5",
            "totalRatingsString": "1K+",
            "promoted": true,
            "adTrackingId": "cid=12000488~p=3~adgrpid=12000488#ag1~mp=SWIGGY_IN~bl=FOOD~eid=d559c21d-d803-43da-b4aa-547179c6967b~aet=RESTAURANT~aeid=413990~srvts=1710779552940",
            "sla": {
                 "deliveryTime": 26,
                 "lastMileTravel": 2.3,
                 "serviceability": "SERVICEABLE",
                 "slaString": "25-30 mins",
                 "lastMileTravelString": "2.3 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 02:00:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "50% OFF",
                 "subHeader": "UPTO ₹100"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "--"
                 }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=413990",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "426638",
            "name": "La Pino'z Pizza",
            "cloudinaryImageId": "yq7lqeehl9dsjjsogv5g",
            "locality": "Khun Khun Ji Road",
            "areaName": "Chowk",
            "costForTwo": "₹300 for two",
            "cuisines": [
                 "Pizzas",
                 "Pastas",
                 "Italian",
                 "Desserts",
                 "Beverages"
            ],
            "avgRating": 4.2,
            "veg": true,
            "parentId": "4961",
            "avgRatingString": "4.2",
            "totalRatingsString": "5K+",
            "sla": {
                 "deliveryTime": 22,
                 "lastMileTravel": 1.5,
                 "serviceability": "SERVICEABLE",
                 "slaString": "20-25 mins",
                 "lastMileTravelString": "1.5 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 04:00:00",
                 "opened": true
            },
            "badges": {
                 "imageBadges": [
                      {
                           "imageId": "v1695133679/badges/Pure_Veg111.png",
                           "description": "pureveg"
                      }
                 ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {
                           "badgeObject": [
                                {
                                     "attributes": {
                                          "imageId": "v1695133679/badges/Pure_Veg111.png",
                                          "description": "pureveg"
                                     }
                                }
                           ]
                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "40% OFF",
                 "subHeader": "UPTO ₹80"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "--"
                 }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=426638",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "579744",
            "name": "Grameen Kulfi",
            "cloudinaryImageId": "td6ljdd9zc3irk96edep",
            "locality": "Dargi Bagh",
            "areaName": "Chowk",
            "costForTwo": "₹120 for two",
            "cuisines": [
                 "Ice Cream",
                 "Desserts"
            ],
            "avgRating": 4.7,
            "veg": true,
            "parentId": "12175",
            "avgRatingString": "4.7",
            "totalRatingsString": "100+",
            "sla": {
                 "deliveryTime": 20,
                 "lastMileTravel": 1.8,
                 "serviceability": "SERVICEABLE",
                 "slaString": "20-25 mins",
                 "lastMileTravelString": "1.8 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 00:00:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "60% OFF",
                 "subHeader": "UPTO ₹120"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "--"
                 }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=579744",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "98035",
            "name": "Siraj Restaurant",
            "cloudinaryImageId": "dbb885737994957796e38b0ba955db2b",
            "locality": "Chowk",
            "areaName": "Chowk",
            "costForTwo": "₹200 for two",
            "cuisines": [
                 "Mughlai",
                 "Biryani",
                 "Lucknowi"
            ],
            "avgRating": 4.4,
            "parentId": "188787",
            "avgRatingString": "4.4",
            "totalRatingsString": "5K+",
            "sla": {
                 "deliveryTime": 23,
                 "lastMileTravel": 2.5,
                 "serviceability": "SERVICEABLE",
                 "slaString": "20-25 mins",
                 "lastMileTravelString": "2.5 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 05:00:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "50% OFF",
                 "subHeader": "UPTO ₹100"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "4.0",
                      "ratingCount": "100+"
                 },
                 "source": "GOOGLE",
                 "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=98035",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },

  {
       "info": {
            "id": "75446",
            "name": "Jahangir Hotel",
            "cloudinaryImageId": "d4638e3377ec4f03a7435c3c61849837",
            "locality": "Nishat Ganj",
            "areaName": "Nishat Ganj",
            "costForTwo": "₹300 for two",
            "cuisines": [
                 "Biryani",
                 "Mughlai",
                 "Rolls & Wraps"
            ],
            "avgRating": 4.2,
            "parentId": "108288",
            "avgRatingString": "4.2",
            "totalRatingsString": "10K+",
            "sla": {
                 "deliveryTime": 29,
                 "lastMileTravel": 5.9,
                 "serviceability": "SERVICEABLE",
                 "slaString": "25-30 mins",
                 "lastMileTravelString": "5.9 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-18 23:59:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      },
                      "textBased": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "₹125 OFF",
                 "subHeader": "ABOVE ₹199",
                 "discountTag": "FLAT DEAL"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "3.8",
                      "ratingCount": "1K+"
                 },
                 "source": "GOOGLE",
                 "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=75446",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "65084",
            "name": "Alamgir Hotel",
            "cloudinaryImageId": "ruczyhnam8hjwkkzgiwl",
            "locality": "Aminabad",
            "areaName": "Aminabad",
            "costForTwo": "₹300 for two",
            "cuisines": [
                 "Mughlai"
            ],
            "avgRating": 4.3,
            "parentId": "29676",
            "avgRatingString": "4.3",
            "totalRatingsString": "10K+",
            "sla": {
                 "deliveryTime": 28,
                 "lastMileTravel": 4.3,
                 "serviceability": "SERVICEABLE",
                 "slaString": "25-30 mins",
                 "lastMileTravelString": "4.3 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 02:00:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textExtendedBadges": {

                      },
                      "textBased": {

                      },
                      "imageBased": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "₹125 OFF",
                 "subHeader": "ABOVE ₹249",
                 "discountTag": "FLAT DEAL"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "4.2",
                      "ratingCount": "1K+"
                 },
                 "source": "GOOGLE",
                 "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=65084",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "65085",
            "name": "Mughal Zaika Aminabad",
            "cloudinaryImageId": "yood4aumr1wbxed1odxk",
            "locality": "Aminabad",
            "areaName": "Aminabad",
            "costForTwo": "₹300 for two",
            "cuisines": [
                 "Mughlai"
            ],
            "avgRating": 4.3,
            "parentId": "140984",
            "avgRatingString": "4.3",
            "totalRatingsString": "10K+",
            "sla": {
                 "deliveryTime": 25,
                 "lastMileTravel": 4.3,
                 "serviceability": "SERVICEABLE",
                 "slaString": "25-30 mins",
                 "lastMileTravelString": "4.3 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 04:00:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "₹125 OFF",
                 "subHeader": "ABOVE ₹199",
                 "discountTag": "FLAT DEAL"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "4.2",
                      "ratingCount": "500+"
                 },
                 "source": "GOOGLE",
                 "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=65085",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "85054",
            "name": "Radhey Lal Sweets",
            "cloudinaryImageId": "ym1t8niwm0mi4lhltkh2",
            "locality": "Sector B",
            "areaName": "Aliganj",
            "costForTwo": "₹150 for two",
            "cuisines": [
                 "Sweets",
                 "South Indian",
                 "Beverages"
            ],
            "avgRating": 4.4,
            "veg": true,
            "parentId": "164352",
            "avgRatingString": "4.4",
            "totalRatingsString": "10K+",
            "promoted": true,
            "adTrackingId": "cid=11997090~p=2~adgrpid=11997090#ag1~mp=SWIGGY_IN~bl=FOOD~eid=420a100d-a7f1-4788-bb32-1c5ea7faca46~aet=RESTAURANT~aeid=85054~srvts=1710779552940",
            "sla": {
                 "deliveryTime": 28,
                 "lastMileTravel": 4.9,
                 "serviceability": "SERVICEABLE",
                 "slaString": "25-30 mins",
                 "lastMileTravelString": "4.9 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-18 22:30:00",
                 "opened": true
            },
            "badges": {
                 "imageBadges": [
                      {
                           "imageId": "v1695133679/badges/Pure_Veg111.png",
                           "description": "pureveg"
                      }
                 ]
            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {
                           "badgeObject": [
                                {
                                     "attributes": {
                                          "description": "pureveg",
                                          "imageId": "v1695133679/badges/Pure_Veg111.png"
                                     }
                                }
                           ]
                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "50% OFF",
                 "subHeader": "UPTO ₹100"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "--"
                 }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=85054",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "76869",
            "name": "Radhey Lal Premium Sweets",
            "cloudinaryImageId": "bzupoiynxjbgogvumixa",
            "locality": "Chowk",
            "areaName": "Chowk",
            "costForTwo": "₹200 for two",
            "cuisines": [
                 "Sweets",
                 "Chinese",
                 "Desserts"
            ],
            "avgRating": 4.5,
            "parentId": "164351",
            "avgRatingString": "4.5",
            "totalRatingsString": "10K+",
            "sla": {
                 "deliveryTime": 16,
                 "lastMileTravel": 1.3,
                 "serviceability": "SERVICEABLE",
                 "slaString": "15-20 mins",
                 "lastMileTravelString": "1.3 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 00:15:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "50% OFF",
                 "subHeader": "UPTO ₹100"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "3.6",
                      "ratingCount": "50+"
                 },
                 "source": "GOOGLE",
                 "sourceIconImageId": "v1704440323/google_ratings/rating_google_tag"
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=76869",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "532693",
            "name": "McDonald's",
            "cloudinaryImageId": "535fc9f9c135f7982317bbb6a64a1ffc",
            "locality": "Habibullah Estate Road",
            "areaName": "Hazratganj",
            "costForTwo": "₹400 for two",
            "cuisines": [
                 "American"
            ],
            "avgRating": 4.4,
            "parentId": "630",
            "avgRatingString": "4.4",
            "totalRatingsString": "1K+",
            "sla": {
                 "deliveryTime": 27,
                 "lastMileTravel": 5,
                 "serviceability": "SERVICEABLE",
                 "slaString": "25-30 mins",
                 "lastMileTravelString": "5.0 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 01:00:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "aggregatedDiscountInfoV2": {

            },
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "--"
                 }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=532693",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  },
  {
       "info": {
            "id": "804656",
            "name": "KFC",
            "cloudinaryImageId": "bd384dc3b5ef057f8b2dcb91f243f33b",
            "locality": "Chandralok",
            "areaName": "Sector E",
            "costForTwo": "₹400 for two",
            "cuisines": [
                 "Burgers",
                 "Biryani",
                 "American",
                 "Snacks",
                 "Fast Food"
            ],
            "avgRating": 4.4,
            "parentId": "547",
            "avgRatingString": "4.4",
            "totalRatingsString": "100+",
            "sla": {
                 "deliveryTime": 30,
                 "lastMileTravel": 4.7,
                 "serviceability": "SERVICEABLE",
                 "slaString": "30-35 mins",
                 "lastMileTravelString": "4.7 km",
                 "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
                 "nextCloseTime": "2024-03-19 01:00:00",
                 "opened": true
            },
            "badges": {

            },
            "isOpen": true,
            "type": "F",
            "badgesV2": {
                 "entityBadges": {
                      "textBased": {

                      },
                      "imageBased": {

                      },
                      "textExtendedBadges": {

                      }
                 }
            },
            "aggregatedDiscountInfoV3": {
                 "header": "20% OFF",
                 "subHeader": "UPTO ₹50"
            },
            "differentiatedUi": {
                 "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                 "differentiatedUiMediaDetails": {
                      "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                      "lottie": {

                      },
                      "video": {

                      }
                 }
            },
            "reviewsSummary": {

            },
            "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
            "isNewlyOnboarded": true,
            "restaurantOfferPresentationInfo": {

            },
            "externalRatings": {
                 "aggregatedRating": {
                      "rating": "--"
                 }
            },
            "ratingsDisplayPreference": "RATINGS_DISPLAY_PREFERENCE_SHOW_SWIGGY"
       },
       "analytics": {

       },
       "cta": {
            "link": "swiggy://menu?restaurant_id=804656",
            "text": "RESTAURANT_MENU",
            "type": "DEEPLINK"
       }
  }

]

export const Card_api = [
  {
  "id":"res1",
  "title":"Food Circles",
  "image":"http://res.cloudinary.com/simpleview/image/upload/v1438123960/clients/grandrapids/file_bcf11a47-7451-464f-8c4d-c9d3e85e9146.png",
  "minCharge":"5.00 LE",
  "rating":"2",
  "titlMC":"foodCirclesMenuCat",
  "url_menucat":"https://gist.github.com/omar94hamza/95723a43bb97f21567c99948c31dc7aa/raw/d09556d7f9591c9ac36d499a48c82d0012589a03/foodcirclesmenucat.json",
  "type":["Chicken", "Meat"]
},
{
  "id":"res2",
  "title":"KFC", 
  "image":"http://vignette1.wikia.nocookie.net/ridiculoushist/images/b/b8/KFC_logo.png",
  "minCharge":"10.00 LE",
  "rating":"8",
  "titlMC":"kfc",
  "url_menucat":"https://gist.github.com/omar94hamza/5915e318a11a40f7a70e440804431e45/raw/9dfee086fc5f6734c7306c17e5fa97e3683df2d8/kfc.json",
  "type":["Fast Food", "Chicken", "Sandwiches"]
},
{
  "id":"res3",
  "title":"Dinware Dines Out", 
  "image":"http://blogs.delawareonline.com/secondhelpings/files/2011/09/DDO-logo.png",
  "minCharge":"6.00 LE",
  "rating":"6",
  "titlMC":"dinwaredinesout",
  "url_menucat":"https://gist.github.com/omar94hamza/00f1be36672b4b12cc3125cc5fb4dc90/raw/c6e6c32835d60ab030258b9c051e73a42aea58b6/dinwaredinesout.json",
  "type":["Burgers", "Fast Food"]
},
{
  "id":"res4",
  "title":"Windmills-rest&cater-vector", 
  "image":"http://www.windmills-cafe.com/default/assets/File/Windmills-rest&cater-vector.png",
  "minCharge":"Free",
  "rating":"3",
  "titlMC":"windmills",
  "url_menucat":"https://gist.github.com/omar94hamza/e01f92414a77f555fcd45255a961a9ba/raw/17ddf8c4e84e5d854084d06e5d8bfeec9bffa79d/windmills.json",
  "type":["Grilled", "Oriental", "Sandwiches"]
},
{
  "id":"res5",
  "title":"BurgerKing", 
  "image":"http://img.zanda.com/item/96060060000053/1024x768/Burger_King_Logo.png",
  "minCharge":"7.00 LE",
  "rating":"8",
  "titlMC":"burgerking",
  "url_menucat":"https://gist.github.com/omar94hamza/c1e7a0220547235c515e3b073bb4e7ff/raw/e122811cf463a8f47d90a5aa7407cc3998dbb21b/burgerking.json",
  "type":["Burgers", "Fast Food"]
},
{
  "id":"res6",
  "title":"Restaurant", 
  "image":"http://image.shutterstock.com/z/stock-vector-food-restaurant-logo-icon-264413183.jpg",
  "minCharge":"16.00 LE",
  "rating":"ten",
  "titlMC":"restaurant",
  "url_menucat":"https://gist.github.com/omar94hamza/9725b018f68150d3e50d9c33ec8a3e93/raw/728fddef7356572f9bb8e7608909b542983d8fd3/restaurant.json",
  "type":["Pizza"]
}]